module.exports = __webpack_public_path__ + "img/tuts-rating-slider-mobile-6.32a0003d.png";